import React, {useState} from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import "./index.scss";
import {useSelector} from "react-redux";

export default function AutoSuggestInput({
  address,
  handleAddressChange,
  handleSelectChange,
  placeholder,
  className,
  fetchCallback,
  disabled,
  prevLocations=[]
}) {

  const [inputClicked, setInputClicked] = useState(false);
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);

  const searchOptions = {
    componentRestrictions: { country: accountData?.operational_countries?.map(country => country?.country_short_name?.toLowerCase()) || "us" },
    types: ["address"],
  };

  const getPlaceDetails = (placeId) => {
    const placesService = new window.google.maps.places.PlacesService(document.createElement("div"));
    placesService.getDetails({ placeId }, (details, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        const fullAddress = details.formatted_address;
        handleAddressChange({
          lat: details.geometry.location.lat(),
          lon: details.geometry.location.lng(),
          address: fullAddress,
          info: details.address_components
        });
      }
    });
  };

  const handleSelect = (address) => {
    setInputClicked(false);
    handleAddressChange(typeof address === "string" ? { address } : address);
    if (fetchCallback) {
      fetchCallback(address);
    }
    geocodeByAddress(address)
        .then(results => {
          if (!results.length) return;
          const placesService = new window.google.maps.places.AutocompleteService();
          placesService.getPlacePredictions(
              {
                input: address,
                componentRestrictions: { country: accountData?.operational_countries?.map(country => country?.country_short_name?.toLowerCase()) || "us" },
                types: ["address"]
              },
              (predictions, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                  if (predictions.length > 0) {
                    const placeId = predictions[0].place_id;
                    getPlaceDetails(placeId);
                  }
                }
              }
          );
        })
        .catch(error => console.error("Geocode Error:", error));
  };

  return (
    <PlacesAutocomplete
      value={address || ''}
      onChange={(e) => {
        handleAddressChange({ address: e });
      }}
      disabled={disabled}
      onSelect={handleSelect}
      searchOptions={searchOptions}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <>
          <input
              style={{cursor: disabled ? 'not-allowed' : ''}}
              readOnly={disabled}
            {...getInputProps({
              placeholder: placeholder,
              className: className,
              onFocus: () => {
                setInputClicked(true)
              },
              onBlur: () => {
                setTimeout(() => {
                  setInputClicked(false)
                }, 150)
              },
            })}
          />
          <div
            className={
              "autocomplete-dropdown-container " +
              (suggestions.length === 0 && !loading && !inputClicked ? "hidden" : "")
            }
          >
            {loading && <div className="suggestion-item">Loading...</div>}
            {inputClicked && address === "" && prevLocations.length ? (
              prevLocations.map((location, index) => (
                <div
                  key={index}
                  className="suggestion-item"
                  onClick={() => handleSelect(location?.full_address)}
                >
                  <span>{location?.full_address}</span>
                </div>
              ))
            ) : (
              suggestions.map((suggestion, index) => {
                const className = suggestion.active
                  ? "suggestion-item active"
                  : "suggestion-item";
                return (
                  <div
                    key={index}
                    {...getSuggestionItemProps(suggestion, {
                      className,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })
            )}
          </div>
        </>
      )}
    </PlacesAutocomplete>
  );
}
